import { IIconBase } from '..'

const eyeHidePasswordIcon = ({
  color = '#333752',
  height = 16,
  width = 16,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M11.8799 3.84633C10.7132 2.96633 9.3799 2.48633 7.9999 2.48633C5.64656 2.48633 3.45323 3.87299 1.92656 6.27299C1.32656 7.21299 1.32656 8.793 1.92656 9.733C2.45323 10.5597 3.06656 11.273 3.73323 11.8463'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.61328 13.0204C6.37328 13.3404 7.17995 13.5138 7.99995 13.5138C10.3533 13.5138 12.5466 12.1271 14.0733 9.72711C14.6733 8.78711 14.6733 7.20711 14.0733 6.26711C13.8533 5.92044 13.6133 5.59378 13.3666 5.28711'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.0748 10.25C9.33125 10.25 10.3498 9.2314 10.3498 7.97495C10.3498 6.7185 9.33125 5.69995 8.0748 5.69995C6.81836 5.69995 5.7998 6.7185 5.7998 7.97495C5.7998 9.2314 6.81836 10.25 8.0748 10.25Z'
        stroke={color}
        strokeWidth='1.5'
      />
    </svg>
  )
}

export default eyeHidePasswordIcon
